<template>
    <v-container>
        <v-chip
                v-if="chip"
                class="ma-2"
                close
                color="orange"
                small
                @click:close="removeReminder"
                @click="sendAlimTalk"
        >
            {{ localText }}
        </v-chip>
    </v-container>
</template>

<script>
import axios from "axios";

export default {
    name: 'ReimnderChip',
    props: {
        orderId: {},
        text: {}
    },
    data: function() {
        return {
            localText: this.text,
            chip: true
        }
    },
    methods: {
        removeReminder() {

            return axios({
                method: 'POST',
                headers: {
                    'Authorization': 'bearer ' + this.$store.getters.getAccessToken
                },
                url: this.$store.getters.getApiUrl + '/api/v1/order/removeReminder/' + this.orderId,
                timeout: this.$store.getters.getApiRequestTimeLimit
            })
            .then(response => {

                if(response.data != null && !response.data.status == '0000'){

                    this.chip = false

                }else{

                    alert('처리에 실패했습니다.\n다시 시도해주세요.')
                    return false

                }

            })
            .catch((error) => {

                if(error && error.name == "InvalidJwtToken"){

                    //JWT 토큰이 정확하지 않을 시
                    alert('인증 토큰이 유효하지 않습니다.')
                    return false

                }else{

                    //저장 실패 시
                    alert('미리알림 제거에 실패했습니다.')

                }

            })

        },
        sendAlimTalk: function() {

            if(!confirm('비즈톡 미리알림 메세지를 전송하시겠습니까?')){
                return false
            }

            const templateCode = "BSTPL004"

            const api_url = this.$store.getters.getApiUrl + '/api/v1/alimtalk/sendAlimTalk/' + this.orderId + '/' + templateCode

            return axios({
                method: 'POST',
                headers: {
                    'Authorization': 'bearer ' + this.$store.getters.getAccessToken
                },
                url: api_url,
                data: {
                    templateNo: 4
                },
                timeout: this.$store.getters.getApiRequestTimeLimit
            })
                .then(async response => {

                    const res = response.data

                    if(res.code == 0){
                        alert(res.message)
                        await this.removeReminder()
                        this.$forceUpdate();
                    }

                })

        }
    }
}
</script>